// extracted by mini-css-extract-plugin
module.exports = {"demos":"demos-module--demos--2Q7R6","demoList":"demos-module--demo-list--3sttX","demoItem":"demos-module--demo-item--31-Cl"};